import Clipboard from 'clipboard';
import { useSnackbar } from '@/components/common/snackbar/use-snackbar';
import { AdpDocument, AdpDocumentOptionAction } from '@/types';
import { getPageUrl } from '@/utils/adpDocument';

export const copyLinkOptionAction: AdpDocumentOptionAction = {
  label: 'リンクをコピー',
  icon: 'chain',
  emitName: 'copy-link',
};

export const useCopyDocumentLink = () => {
  const { createSnackbar } = useSnackbar();

  const notify = (isSuccess: boolean) => {
    createSnackbar({
      message: isSuccess
        ? 'リンクをコピーしました'
        : 'リンクをコピーできませんでした',
      type: isSuccess ? 'success' : 'error',
    });
  };

  const copyLink = async (adpDocument: AdpDocument) => {
    const text = getPageUrl(adpDocument, true);
    if (!text) {
      notify(false);
      return;
    }

    await new Promise<void>(resolve => {
      const trigger = document.createElement('button');
      const clipboard = new Clipboard(trigger, { text: () => text });
      const finalize = (isSuccess: boolean) => {
        notify(isSuccess);
        clipboard.destroy();
        trigger.remove();
        resolve();
      };
      clipboard.on('success', () => finalize(true));
      clipboard.on('error', () => finalize(false));
      document.body.appendChild(trigger);
      trigger.click();
    });
  };

  return { copyLink };
};
